module.exports = "/_next/static/images/img_list-3-128cfb4b844bd17f6dad28c6d7a02075.webp";